import * as UserRoutes from './UserRoutes';
import * as CreativesRoutes from './CreativesRoutes';
import * as CategoriesRoutes from './CategoriesRoutes';
import * as InstagramRoutes from './InstagramRoutes';

export const ApiRoutes = {
  User: UserRoutes,
  Creatives: CreativesRoutes,
  Categories: CategoriesRoutes,
  Instagram: InstagramRoutes,
} as const;
